import { render, staticRenderFns } from "./RestorationDetails.vue?vue&type=template&id=453f1938&scoped=true&"
import script from "./RestorationDetails.vue?vue&type=script&lang=js&"
export * from "./RestorationDetails.vue?vue&type=script&lang=js&"
import style0 from "./RestorationDetails.vue?vue&type=style&index=0&id=453f1938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453f1938",
  null
  
)

export default component.exports